import { reactive } from 'vue'

export const dialogState = reactive({
  visible: false,
  title: '',
  message: '',
  type: 'info',
  confirmText: 'OK',
  cancelText: 'Cancel',
  showCancel: false,
  closeOnBackdrop: false,
  resolve: null,
})

let dialogChain = Promise.resolve()

function enqueueDialog(run) {
  dialogChain = dialogChain.then(() => run()).catch(() => {})
  return dialogChain
}

function openDialog(options = {}) {
  return new Promise((resolve) => {
    dialogState.visible = true
    dialogState.title = options.title || ''
    dialogState.message = String(options.message || '')
    dialogState.type = options.type || 'info'
    dialogState.confirmText = options.confirmButtonText || 'OK'
    dialogState.cancelText = options.cancelButtonText || 'Cancel'
    dialogState.showCancel = Boolean(options.showCancel)
    dialogState.closeOnBackdrop = options.closeOnClickModal ?? false
    dialogState.resolve = (result) => {
      dialogState.visible = false
      dialogState.resolve = null
      resolve(result)
    }
  })
}

export function resolveAppDialog(result = true) {
  dialogState.resolve?.(result)
}

export function showAppDialog(options = {}) {
  return enqueueDialog(() => openDialog(options))
}

export async function showAppAlert(message, title = '', options = {}) {
  await showAppDialog({
    title,
    message,
    type: options.type || 'info',
    confirmButtonText: options.confirmButtonText,
    closeOnClickModal: options.closeOnClickModal,
  })
  return true
}

export async function showAppConfirm(message, title = '', options = {}) {
  const result = await showAppDialog({
    title,
    message,
    type: options.type || 'info',
    confirmButtonText: options.confirmButtonText,
    cancelButtonText: options.cancelButtonText,
    showCancel: true,
    closeOnClickModal: options.closeOnClickModal,
  })
  return Boolean(result)
}
